import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()

export class CustomersService {

  httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient) { }

  getCustomers() {
    let config = {
        headers: new HttpHeaders({'Content-Type':'application/json'})
      };

      return this.http.get('/customers', config);
  }
  
  searchCustomers(query) {
      return this.http.get('/customers/search?q='+query);
  }

  createCustomer(data) {
      let body = JSON.stringify(data);
      return this.http.post('/customers/', body, this.httpOptions);
  }

  updateCustomer(data) {
      let body = JSON.stringify(data);
      return this.http.put('/customers/' + data.id, body, this.httpOptions);
  }

  deleteCustomer(data) {
      return this.http.delete('/customers/' + data.id);
  }

  getCount(){
    return this.http.get('/customers/count');
  }

  getCustomerById(id) {
    let q = JSON.stringify({"where": {"id": id }});
    return this.http.get('/customers?filter='+q);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/services/customers/customers.service.ts